export const UNIT_TYPES = {
  SI: 'SI',
  US: 'US',
} as const;

export const FIELD_TYPES = {
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  TEXT: 'text',
  RADIO: 'radio',
} as const;

export const FIELD_NAMES = {
  SELECTED_MODEL: 'selectedModel',
  UNIT_TYPE: 'unitType',
  ATMOSPHERIC_PRESSURE: 'atmosphericPressure',
  DISCHARGE_ABSOLUTE_PRESSURE: 'dischargeAbsolutePressure',
  ALTITUDE_FROM_SEA_LEVEL: 'altitudeFromSeaLevel',
} as const;

export default {
  UNIT_TYPES,
  FIELD_TYPES,
  FIELD_NAMES,
};
